import React, { PropsWithChildren, useEffect, useState } from 'react';
import { TbMoodConfuzed } from 'react-icons/tb';
import Drawer from './Drawer';
import CustomerService from '../../Services/CustomerService';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { ImSpinner8 } from 'react-icons/im';
import CardOrderDetail from './CardOrderDetail';
import Scrollbars from 'react-custom-scrollbars-2';
import OrderService from '../../Services/OrderService';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import BoxContentEndScrollbars from './BoxContentEndScrollbars';
import { useCartContext } from '../../Contexts/CartContext';
import { useTranslation } from 'react-i18next';

interface ButtonCustomerOrdersProps {
    className?: string;
}

const ButtonCustomerOrders = ({className, children}: PropsWithChildren<ButtonCustomerOrdersProps>) => {

    const { t } = useTranslation();
    const [showOrders, setShowOrders] = useState(false);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [ordersList, setOrdersList] = useState([]);
    const { orderType, isStoreCounter } = useOrderTypeContext();
    const { setCurrentOrder, showOrderDetail, setShowOrderDetail, setLoadingOrderDetail } = useCartContext();

    const getOrdersList = async () => {
        setShowOrders(true);
        setLoadingOrders(true);
        try {
            const customerService = new CustomerService(orderType);
            const getList = await customerService.getOrders();
            if (getList) {
                setOrdersList(getList);
            }
        } catch (error) {
            console.error('Error getOrdersList:', error);
        } finally {
            setLoadingOrders(false);
        }
    }

    const { setMainLoading, setMainLoadingIcon, setMainLoadingIconError, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, isMobile } = useLayoutContext();
    const getDetail = async (order_id: number) => {
        const payload = {
            order_id: order_id,
        }
        setShowOrderDetail(true);
        setLoadingOrderDetail(true);
        try {
            const orderService = new OrderService(orderType);
            const details = await orderService.detail(payload);

            if (details) {
                setCurrentOrder(details);
            }
        } catch (error) {
            console.error('Error orderDetail:', error);
            setShowOrderDetail(false);
            setLoadingOrderDetail(false);

            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconError(true);
            setMainLoadingTitle(t('errors.default_title'));
            setMainLoadingMessage(
                isStoreCounter 
                    ?   t('errors.default_message_store_counter')
                    :   t('errors.default_message')
            );
            setMainLoadingCloseButton(true);
        } finally {
            setLoadingOrderDetail(false);
        }
    }

    const handleGetDetail = (order_id: number) => {
        setShowOrderDetail(true); 
        getDetail(order_id);
    }

    useEffect(() => {
        if (!showOrderDetail) {
            setTimeout(() => {//* setTimeout apenas layout
                setCurrentOrder(null);
            }, 250);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOrderDetail])


    const [showShadow, setShowShadow] = useState(false);
    const handleScrollFrame = (values: any) => {
        const { scrollTop, scrollHeight, clientHeight } = values;
        // Verifica se o scroll está no início ou no fim para controlar a sombra
        if (scrollTop >= 0 && scrollTop + clientHeight < scrollHeight) {
            setShowShadow(true);
        } else {
            setShowShadow(false);
        }
    }

    useEffect(() => {
        //* Exibição da sombra dos itens quando houver scroll
        const boxScroll = document.getElementById('boxScroll_customerOrders');
        const scrollContent = document.getElementById('scrollContent_customerOrders');

        if (boxScroll && scrollContent) {
            const boxScrollHeight = boxScroll.getBoundingClientRect().height;
            const scrollContentHeight = scrollContent.getBoundingClientRect().height;
            setShowShadow(scrollContentHeight > boxScrollHeight)
        }
    }, [ordersList])

    return (
        <>
            {(isStoreCounter) &&
                <>
                    <div onClick={() => getOrdersList()} className={className}>
                        {children}
                    </div>

                    <Drawer open={showOrders}
                        title={t('profile.orders.button_customer_orders_label')}
                        subtitle={''}
                        className={isMobile ? 'ml-2' : ''}
                        onClose={() => setShowOrders(false)}
                        >
                        <section className='p-4 pt-3 flex flex-col h-full gap-4 justify-between'>
                            <div className="h-full">
                                {loadingOrders 
                                    ? <div className="flex items-center justify-center gap-1 h-full text-gray-500"><ImSpinner8 className="animate-spin" /> <span>{t('layout.loading')}</span></div>
                                    :
                                        ordersList.length === 0
                                            ?   <div className="flex items-center justify-center gap-1 h-full text-gray-500"><TbMoodConfuzed /> <span>{t('profile.orders.no_orders_found')}</span></div>
                                            :
                                                <div className='relative flex flex-col gap-3 w-full h-full md:overflow-y-auto'>
                                                    <div className='relative h-full min-h-24' id="boxScroll_customerOrders">

                                                        <Scrollbars autoHide={true} className='min-h-full' onScrollFrame={handleScrollFrame}>
                                                            <div className='flex flex-col divide-y divide-gray-100' id='scrollContent_customerOrders'>
                                                                {ordersList.map((order: any, index: number) => 
                                                                    <CardOrderDetail order={order} onClick={() => handleGetDetail(order.id)} key={index} />
                                                                )}
                                                            </div>
                                                            <BoxContentEndScrollbars message={t('profile.orders.end_of_list')} />
                                                        </Scrollbars>
                                                        <div className={`absolute hidden md:block bottom-0 w-full h-2 shadow-reverse-md transition ${showShadow ? 'opacity-100' : 'opacity-0'}`}></div>
                                                    </div>
                                                    <div className={`absolute -bottom-2 md:hidden w-full h-2 shadow-reverse-md transition ${showShadow ? 'opacity-100' : 'opacity-0'}`}></div>
                                                </div>

                                }
                            </div>
                        </section>
                    </Drawer>
                </>
            }
        </>
    );
};

export default ButtonCustomerOrders;
